<template>
  <div class="">
    <category-layout>
      <section class="about-item-area">
        <div class="container">
          <div class="bg-white pt-20 pb-20 pc-padding" v-loading="isLoading">
            <div class="divider mt-5 mb-15"></div>
            <EventInfo 
              v-if="event" 
              :event="event"
              :status="manuscript && manuscript.status !== null ? manuscript.status : undefined"
              :ticket="ticket"
              :orderpaystatus="orderStatus !== null ? orderStatus : undefined"
            />
            <el-divider></el-divider>

            <template v-if="allowreg && event && event.closetime > Math.floor(Date.now() / 1000)">
              <!-- 基本信息表单 -->
              <el-form 
                ref="basicForm" 
                :rules="rules" 
                :model="formData" 
                label-width="80px" 
                class="basic-info-form mb-30"
              >
                <el-row :gutter="20">
                  <el-col :span="8" :xs="24">
                    <el-form-item label="姓名" prop="author.realname">
                      <el-input v-model="formData.author.realname" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8" :xs="24">
                    <el-form-item label="性别" prop="author.gender">
                      <el-select v-model="formData.author.gender" placeholder="请选择性别">
                        <el-option label="男" :value="1"></el-option>
                        <el-option label="女" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  
                  <el-col :span="8" :xs="24">
                    <el-form-item label="年龄" prop="author.age">
                      <el-input v-model.number="formData.author.age" type="number" placeholder="请输入年龄"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row :gutter="20">
                  <el-col :span="8" :xs="24">
                    <el-form-item label="学校" prop="author.institution">
                      <el-input v-model="formData.author.institution" placeholder="请输入学校名称"></el-input>
                    </el-form-item>
                  </el-col>
                  
                  <el-col :span="8" :xs="24">
                    <el-form-item label="院系" prop="author.department">
                      <el-input v-model="formData.author.department" placeholder="请输入院系名称"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row :gutter="20">                
                  <el-col :span="8" :xs="24">
                    <el-form-item label="职务" prop="author.position">
                      <el-input v-model="formData.author.position" placeholder="请输入职务"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8" :xs="24">
                    <el-form-item label="职称" prop="author.title">
                      <el-input v-model="formData.author.title" placeholder="请输入职称"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                  
                <el-row :gutter="20"> 
                  <el-col :span="8" :xs="24">
                    <el-form-item label="联系电话" prop="author.cellphone">
                      <el-input v-model="formData.author.cellphone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                  </el-col>
                  
                  <el-col :span="8" :xs="24">
                    <el-form-item label="电子邮箱" prop="author.email">
                      <el-input v-model="formData.author.email" type="email" placeholder="请输入电子邮箱"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="16" :xs="24">
                    <el-form-item label="课题名称" prop="title">
                      <el-input v-model="formData.title" placeholder="请输入课题名称"></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24" :xs="24">
                    <el-form-item label="研究方向" prop="summary">
                      <el-input type="textarea" :rows="4" v-model="formData.summary" placeholder="请输入研究方向"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :xs="24">
                    <el-form-item label="项目成员" prop="authors">
                      <el-button 
                        type="primary" 
                        @click="addAuthor"
                        class="mb-2"
                      >添加项目成员</el-button>
                    
                      <el-table :data="formData.authors" border style="width: 100%">
                        <el-table-column prop="realname" label="姓名" width="100">
                          <template slot-scope="scope">
                            <el-popover trigger="hover" placement="top" v-if="scope.row.realname">
                              <p>姓名: {{ scope.row.realname }}</p>
                              <p>学校: {{ scope.row.institution }}</p>
                              <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">{{ scope.row.realname }}</el-tag>
                              </div>
                            </el-popover>
                            <div v-else class="name-wrapper"></div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="gender" label="性别" width="60">
                          <template slot-scope="scope">
                            <span v-if="scope.row.gender == 1">男</span>
                            <span v-else-if="scope.row.gender == 2">女</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="cellphone"  label="联系电话" width="120"></el-table-column>
                        <el-table-column prop="institution" label="学校"></el-table-column>
                        <el-table-column prop="title" label="职称"></el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="editAuthor(scope.$index)">编辑</el-button>
                            <el-button type="danger" size="mini" @click="removeAuthor(scope.$index)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              
              <template v-if="(!mid && getEndOfDayTimestamp(event.starttime) > Math.floor(Date.now() / 1000)) || (manuscript && manuscript.status == 0)">
                <div class="form-actions mt-30 text-center">
                  <el-button type="primary" @click="submitForm" :disabled="isSubmitting">提交</el-button>
                  <el-button @click="resetForm">重置</el-button>
                </div>
              </template>

              <template v-if="manuscript && manuscript.status >= 0 && manuscript.status < 5">
                <el-divider></el-divider>
              </template>
              
              <!-- 报名附件上传区域 -->
              <div class="mb-30" v-if="(manuscript && manuscript.status == 0)">
                <el-row :gutter="20">
                  <div class="upload-card">
                    <h4 class="upload-title">报名材料</h4>
                    <div v-if="files1.length > 0">
                      <el-descriptions title="" :column="2">
                        <template v-for="(item, index) in files1">
                          <el-descriptions-item :key="`name-${index}`">
                            {{ item.name }}
                          </el-descriptions-item>
                          <el-descriptions-item :key="`action-${index}`" label="">
                            <el-button 
                              icon="el-icon-download"
                              type="primary" 
                              size="mini" 
                              @click="downloadFile(item.fileurl)"
                            >下载</el-button>
                            <el-button 
                              v-if="manuscript && manuscript.status == 0"
                              icon="el-icon-delete-solid"
                              type="danger" 
                              size="mini" 
                              @click="removeFile(item.id)"
                            >删除</el-button>
                          </el-descriptions-item>
                        </template>
                      </el-descriptions>
                    </div>

                    <el-upload
                      v-else
                      class="upload-demo"
                      ref="upload"
                      action="#"
                      accept=".zip,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-success="handleUploadSuccess"
                      :auto-upload="true"
                      :limit="1"
                      :http-request="uploadAction1"
                      :before-upload="beforeUpload"
                    >
                      <el-button slot="trigger" size="small" type="primary">上传附件</el-button>
                      <div slot="tip" class="el-upload__tip">
                        <div class="text-red">1、请提交项目信息后，再上传附件</div>
                        <div>2、上传文件支持PDF、DOC和ZIP格式，单个文件大小限制为20MB以内</div>
                        <div>3、若上传多个文件，请使用ZIP压缩包</div>
                      </div>
                    </el-upload>
                  </div>
                </el-row>
              </div>

              <div class="mb-30" v-else-if="event && event.type == 20 && manuscript && (manuscript.status == 1 || manuscript.status == 2) &&
                timelineData[1] && timelineData[1].timestamp &&
                Math.floor(Date.now() / 1000) <= getEndOfDayTimestamp(timelineData[1].timestamp)
              ">
                <el-row :gutter="20">
                  <div class="upload-card">
                    <h4 class="upload-title">中期材料上传</h4>
                    <div v-if="files2.length > 0">
                      <el-descriptions title="" :column="2">
                        <template v-for="(item, index) in files2">
                          <el-descriptions-item :key="`name-${index}`">
                            {{ item.name }}
                          </el-descriptions-item>
                          <el-descriptions-item :key="`action-${index}`" label="">
                            <el-button 
                              icon="el-icon-download"
                              type="primary" 
                              size="mini" 
                              @click="downloadFile(item.fileurl)"
                            >下载</el-button>
                            <el-button 
                              v-if="manuscript && (manuscript.status == 1 || manuscript.status == 2)"
                              icon="el-icon-delete-solid"
                              type="danger" 
                              size="mini" 
                              @click="removeFile(item.id)"
                            >删除</el-button>
                          </el-descriptions-item>
                        </template>
                      </el-descriptions>
                    </div>

                    <el-upload
                      v-else
                      class="upload-demo"
                      ref="upload"
                      action="#"
                      accept=".zip,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-success="handleUploadSuccess"
                      :auto-upload="true"
                      :limit="1"
                      :http-request="uploadAction2"
                      :before-upload="beforeUpload"
                    >
                      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                      <div slot="tip" class="el-upload__tip">
                        <div>1、上传文件支持PDF、DOC和ZIP格式，单个文件大小限制为20MB以内</div>
                        <div>2、若上传多个文件，请使用ZIP压缩包</div>
                      </div>
                    </el-upload>
                  </div>
                </el-row>
              </div>

              <div class="mb-30" v-else-if="event && event.type == 20 && manuscript && (manuscript.status == 3 || manuscript.status == 4) && 
                timelineData[2] && timelineData[2].timestamp &&
                Math.floor(Date.now() / 1000) <= getEndOfDayTimestamp(timelineData[2].timestamp)
              ">
                <el-row :gutter="20">
                  <div class="upload-card">
                    <h4 class="upload-title">结项材料上传</h4>
                    <div v-if="files3.length > 0">
                      <el-descriptions title="" :column="2">
                        <template v-for="(item, index) in files3">
                          <el-descriptions-item :key="`name-${index}`">
                            {{ item.name }}
                          </el-descriptions-item>
                          <el-descriptions-item :key="`action-${index}`" label="">
                            <el-button 
                              icon="el-icon-download"
                              type="primary" 
                              size="mini" 
                              @click="downloadFile(item.fileurl)"
                            >下载</el-button>
                            <el-button 
                              v-if="manuscript && (manuscript.status == 3 || manuscript.status == 4)"
                              icon="el-icon-delete-solid"
                              type="danger" 
                              size="mini" 
                              @click="removeFile(item.id)"
                            >删除</el-button>
                          </el-descriptions-item>
                        </template>
                      </el-descriptions>
                    </div>

                    <el-upload
                      v-else
                      class="upload-demo"
                      ref="upload"
                      action="#"
                      accept=".zip,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-success="handleUploadSuccess"
                      :auto-upload="true"
                      :limit="1"
                      :http-request="uploadAction3"
                      :before-upload="beforeUpload"
                    >
                      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                      <div slot="tip" class="el-upload__tip">
                        <div>1、上传文件支持PDF、DOC和ZIP格式，单个文件大小限制为20MB以内</div>
                        <div>2、若上传多个文件，请使用ZIP压缩包</div>
                      </div>
                    </el-upload>
                  </div>
                </el-row>
              </div>

              <!-- 时间线区域 -->
              <div class="timeline-section mt-30" v-if="event && event.type == 20 && (!manuscript || manuscript.status != -90)">
                <el-timeline>
                  <el-timeline-item
                    v-for="(item, index) in timelineData"
                    :key="index"
                    :class="{'timeline-red-highlight': isTimelineItemActive(item, index)}"
                  >
                    <template #timestamp>
                      <span v-html="formatTimelineTimestamp(item.timestamp)"></span>
                    </template>
                    <el-card>
                      <div class="custom-timestamp" v-html="formatTimelineTimestamp(item.timestamp)"></div>
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.content }}</p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>

              <!-- 附件下载区域 -->
              <div class="mb-30" v-if="files.length > 0 || files1.length > 0 || files2.length > 0 || files3.length > 0">
                <el-divider></el-divider>
                <el-row :gutter="20">
                  <div>
                    <div class="download-text">
                      点击下方下载附件：
                    </div>
                    <template v-for="(file, index) in files">
                      <div :key="`file-${index}`">
                        <a class="download-file" :href="file.fileurl" target="_blank">
                          附件 {{ index + 1 }}：{{ file.name }}</a>
                      </div>
                    </template>

                    <template v-for="(file, index) in files1">
                      <div :key="`file1-${index}`">
                        <a class="download-file" :href="file.fileurl" target="_blank">
                          报名材料： {{ index + 1 }}：{{ file.name }}</a>
                      </div>
                    </template>

                    <template v-for="(file, index) in files2">
                      <div :key="`file2-${index}`">
                        <a class="download-file" :href="file.fileurl" target="_blank">
                          中期材料： {{ index + 1 }}：{{ file.name }}</a>
                      </div>
                    </template>

                    <template v-for="(file, index) in files3">
                      <div :key="`file3-${index}`">
                        <a class="download-file" :href="file.fileurl" target="_blank">
                          结项材料： {{ index + 1 }}：{{ file.name }}</a>
                      </div>
                    </template>
                  </div>
                </el-row>
              </div>

              <!-- 工作人员联系方式 -->
              <template v-if="manuscript && manuscript.status >= 0 && sales && sales.id">
                <div class="staff-contact-section mt-30 bg-white">
                  <div class="contact-tip mb-20 text-center">
                    请添加工作人员的联系方式，便于跟进项目进展。
                  </div>
                  
                  <el-row :gutter="30">
                    <el-col :span="12" :xs="24">
                      <el-descriptions :column="1" border class="contact-info">
                        <el-descriptions-item label="姓名">{{ sales.realname || sales.fullname }}</el-descriptions-item>
                        <el-descriptions-item label="联系电话">{{ sales.cellphone }}</el-descriptions-item>
                        <el-descriptions-item label="电子邮箱">{{ sales.email }}</el-descriptions-item>
                      </el-descriptions>
                    </el-col>
                    
                    <el-col :span="12" :xs="24" class="qrcode-column text-center">
                      <template v-if="sales.wxqrcode">
                        <vue-qrcode 
                          display-value="false"
                          v-if="sales.wxqrcode"
                          :value="sales.wxqrcode" 
                          :color="{ dark: '#000000' }"
                          type="image/png"
                          :size="150"
                          @change="onDataUrlChange"
                        />
                        <img 
                          v-if="qrcodeDataUrl" 
                          :src="qrcodeDataUrl" 
                          alt="二维码" 
                          class="qrcode-img"
                        >
                        <p class="qrcode-tip mt-10">扫码添加微信</p>
                      </template>
                    </el-col>
                  </el-row>
                </div>
              </template>

              <!-- 编辑项目成员弹窗 -->
              <el-dialog 
                title="编辑项目成员" 
                :visible="editDialogVisible" 
                width="50%"
                @close="cancelEdit"
              >
                <el-form 
                  ref="editForm" 
                  :model="editAuthorData"
                  :rules="authorRules" 
                  label-width="80px"
                >
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="姓名" prop="realname">
                        <el-input 
                          v-model="editAuthorData.realname" 
                          placeholder="请输入姓名"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="性别" prop="gender">
                        <el-select v-model="editAuthorData.gender" placeholder="请选择性别">
                          <el-option label="男" :value="1"></el-option>
                          <el-option label="女" :value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="年龄" prop="age">
                        <el-input v-model.number="editAuthorData.age" placeholder="请输入年龄"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="学校" prop="institution">
                        <el-input v-model="editAuthorData.institution" placeholder="请输入学校名称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="院系" prop="department">
                        <el-input v-model="editAuthorData.department" placeholder="请输入院系名称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职务" prop="position">
                        <el-input v-model="editAuthorData.position" placeholder="请输入职务"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职称" prop="title">
                        <el-input v-model="editAuthorData.title" placeholder="请输入职称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话" prop="cellphone">
                        <el-input 
                          v-model="editAuthorData.cellphone" 
                          placeholder="请输入联系电话"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="电子邮箱" prop="email">
                        <el-input 
                          v-model="editAuthorData.email" 
                          type="email" 
                          placeholder="请输入电子邮箱"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="cancelEdit">取消</el-button>
                  <el-button type="primary" @click="saveAuthor">保存</el-button>
                </div>
              </el-dialog>

              <!-- 提交成功提示弹窗 -->
              <el-dialog
                title="提示"
                :visible.sync="dialogTipVisible"
                width="30%"
              >
                <span>提交成功，若有其他附件，请在表单下方【报名材料】处继续上传。</span>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogTipVisible = false">确 定</el-button>
                </span>
              </el-dialog>
            </template>

            <template v-else-if="!isLoading">
              <el-empty description="当前项目已结项，看看其他项目吧~"></el-empty>
            </template>
          </div>
        </div>
      </section>
    </category-layout>

    <!-- 支付面板弹窗 -->
    <el-dialog
      title="支付评审费"
      :visible.sync="showPaymentPanel"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="payment-container">
        <div class="payment-header">
          <p>收费项目：评审费</p>
          <p class="price">¥{{ displayPayPrice }}</p>
        </div>
      
        <el-radio-group v-model="selectedPaymentMethod" class="payment-methods">
          <el-radio label="wechat" v-if="payment3id">微信支付</el-radio>
          <el-radio label="alipay" v-if="payment2id">支付宝支付</el-radio>
          <el-radio label="transfer" v-if="payment4id">对公转账</el-radio>
        </el-radio-group>

        <!-- 1. 微信/支付宝支付：显示二维码 -->
        <div v-if="selectedPaymentMethod === 'wechat' || selectedPaymentMethod === 'alipay'" class="qrcode-section">
          <vue-qrcode 
            display-value="false"
            :value="getPaymentQrcodeUrl()" 
            :color="{ dark: '#000000' }"
            type="image/png"
            :size="200"
            @change="onPaymentQrcodeChange"
          />
          <img 
            v-if="paymentQrcodeDataUrl" 
            :src="paymentQrcodeDataUrl" 
            :alt="selectedPaymentMethod === 'wechat' ? '微信支付二维码' : '支付宝支付二维码'"
            class="payment-qrcode"
          >
          <p class="mt-10">请使用 {{ selectedPaymentMethod === 'wechat' ? '微信' : '支付宝' }} 扫码支付</p>
          <p class="mt-5 text-red">支付完成后请点击【我已付款】完成操作</p>
        </div>

        <!-- 2. 对公转账：显示专属二维码（核心修改） -->
        <div v-else-if="selectedPaymentMethod === 'transfer'" class="qrcode-section">
          <vue-qrcode 
            display-value="false"
            :value="getTransferQrcodeUrl()"
            :color="{ dark: '#000000' }"
            type="image/png"
            :size="200"
            @change="onPaymentQrcodeChange"
          />
          <img 
            v-if="paymentQrcodeDataUrl" 
            :src="paymentQrcodeDataUrl" 
            alt="对公转账二维码"
            class="payment-qrcode"
          >
          <p class="mt-10">请扫码查看对公转账信息</p>
          <p class="mt-5 text-red">转账完成后请点击【我已付款】完成操作</p>
        </div>
      </div>

      <!-- 底部按钮：统一为“我已付款”（核心修改） -->
      <div slot="footer" class="dialog-footer">
        <el-button 
          type="primary" 
          @click="handlePaymentCompleted"
          :loading="paymentLoading"
        >
          我已付款
        </el-button>
        <el-button @click="showPaymentPanel = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 支付提醒弹窗 -->
    <el-dialog
      title="待支付提醒"
      :visible.sync="paymentReminderVisible"
      width="30%"
    >
      <p>您有一笔评审费（¥{{ displayPayPrice }}）待支付，请完成支付后继续操作。</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentReminderVisible = false">稍后支付</el-button>
        <el-button type="primary" @click="handleGoToPayment">去支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'
import config from '@/config';
import CategoryLayout from "./CategoryLayout.vue";
import EventInfo from "./EventInfo.vue";
import { 
  getManuscript,
  postManuscript
} from "@/api/manuscripts";
import { 
  getEventSettings,
  getEventFiles,
  getEventTicketList,
  getPaychannels
} from "@/api/event";
import { 
  getMeManuscripts,
  putMeManuscript,
  postMeManuscriptFile,
  getMeManuscriptFile,
  offlineMeManuscriptFile,
  confirmMeManuscript,
  getMeOrders
} from '@/api/user';
import {
  getOrder,
  postOrder,
  postCharge
} from '@/api/order';

import profileService from '@/utils/profileService';
import { formatTimestampToDate } from '@/utils/dateUtil';
import { eventBus } from '@/utils/eventBus.js';

export default {
  components: { 
    CategoryLayout,
    EventInfo,
    VueQrcode
  },
  inject: ['dataWrapper', 'fetchStatus','eventFetchStatus'],
  data() {
    return {
      isLoading: true,
      dialogTipVisible: false,
      qrcodeDataUrl: '',
      paymentQrcodeDataUrl: '',
      isSubmitting: false,
      allowreg: false,
      eventid: null,
      event: null,
      manuscriptid: null,
      mid: null,
      manuscript: null,
      editIndex: -1,
      editDialogVisible: false,
      editAuthorData: {},
      formData: {
        author: {
          realname: '',     // 姓名
          gender: '',       // 性别
          age: null,        // 年龄
          institution: '',  // 学校
          department: '',   // 院系
          position: '',     // 职务
          title: '',        // 职称
          cellphone: '',    // 联系电话
          email: ''         // 电子邮箱
        },
        authors: [],
        title: '',
        summary: ''
      },
      files:[],//活动文件
      files1:[],//报名材料
      files2:[],//中期材料
      files3:[],//结项材料
      sales: [],
      uploadLoading: false,
      // 时间线数据
      timelineData: [
        {
          timestamp: null,
          title: '课题申报开始',
          content: '请填写报名信息，并提交附件'
        },
        {
          timestamp: null,
          title: '中期材料提交截止时间',
          content: '报名审核通过后，以附件的形式上传'
        },
        {
          timestamp: null,
          title: '结项材料提交截止时间',
          content: '中期材料审核通过，以附件的形式上传'
        },
        {
          timestamp: null,
          title: '结项时间',
          content: '项目结束'
        }
      ],
      // 表单验证规则
      rules: {
        'author.realname': [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '姓名长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        'author.gender': [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        'author.age': [
          { required: true, message: '请输入年龄', trigger: 'blur' },
          { type: 'number', message: '年龄必须为数字值', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value < 18 || value > 100) {
                callback(new Error('年龄必须在 18 到 100 之间'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
        'author.institution': [
          { required: true, message: '请输入学校名称', trigger: 'blur' }
        ],
        'author.department': [
          { required: true, message: '请输入院系名称', trigger: 'blur' }
        ],
        'author.cellphone': [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        'author.email':[
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: '请输入正确的电子邮箱格式', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入课题名称', trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入课题方向', trigger: 'blur' }
        ]
      },
      authorRules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '姓名长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        age: [
          { required: true, message: '请输入年龄', trigger: 'blur' },
          { type: 'number', message: '年龄必须为数字值', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value < 18 || value > 100) {
                callback(new Error('年龄必须在 18 到 100 之间'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ],
        institution: [
          { required: true, message: '请输入学校名称', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请输入院系名称', trigger: 'blur' }
        ],
        cellphone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: '请输入正确的电子邮箱格式', trigger: 'blur' }
        ]
      },
      // 支付相关配置
      showPaymentPanel: false,
      selectedPaymentMethod: 'wechat', // 默认微信支付
      paymentLoading: false,
      transferPaymentId: '', // 对公转账渠道ID
      transferFileList: [], // 对公转账文件列表
      transferRemark: '',   // 对公转账备注
      transferScreenshot: null, // 付款截图文件
      paymentCompleted: false,
      paymentReminderVisible: false,
      paymentMethods: [
        { value: 'wechat', label: '微信支付' },
        { value: 'alipay', label: '支付宝支付' },
        { value: 'transfer', label: '对公转账', 
          accountInfo: {
            bankName: '招商银行北京清华园科技金融支行',
            accountNo: '1109 2277 9910 701',
            accountName: '北京水清木华国际文化交流中心'
          }
        }
      ],
      ticket: { price: undefined },
      payment2id: '',
      payment3id: '',
      payment4id: '',
      orderId: '', // 新增：存储创建的订单ID
      orderPrice: undefined, // 新增：订单金额
      orderStatus: undefined, // 新增：订单状态
      // 新增：票价缓存相关
      ticketFetched: false, // 标记是否已获取过票价
      ticketCache: null,     // 缓存票价数据

      alipayQrcodeDataUrl: '', // 新增：支付宝支付二维码数据URL
    };
  },
  created() {
    this.eventid = this.$route.params.id;
    this.event = this.dataWrapper.eventData;  

    this.manuscriptid = this.$route.query.manuscriptid || null;
    
    eventBus.$on('userLoggedIn', this.handleUserLoggedIn);
    eventBus.$on('userLoggedOut', this.handleUserLoggedOut);

    const token = localStorage.getItem('token');
    if (!token) {
      this.$message({
        message: '请先登录',
        type: 'warning',
      });
      return;
    }

    this.$nextTick(() => {
      if (this.userProfile) {
        // 初始化时先预加载票价（只加载一次）
        this.getTicketPrice(true)
          .then(() => {
            this.fetchManuscript(); // 确保票价加载完成后再获取稿件信息
          });
      } else {
        const unwatch = this.$watch('userProfile', (newVal) => {
          if (newVal) {
            this.getTicketPrice(true)
              .then(() => {
                this.fetchManuscript();
                unwatch();
              });
          }
        });
      }
    });
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    },
    // 核心：统一处理支付价格显示
    displayPayPrice() {
      // 优先级：orderPrice（订单实际金额） > ticket.price（票价） > 兜底0.00
      const price = this.orderPrice ?? this.ticket.price ?? '0.00';
      
      // 统一格式：确保是保留2位小数的字符串（兼容数字/字符串输入）
      return Number(price).toFixed(2);
    },
    
    // 辅助：判断是否需要显示支付提醒（可选）
    shouldShowPaymentReminder() {
      const price = Number(this.displayPayPrice);
      return price > 0 && this.mid && this.manuscript?.orderpaystatus !== 100;
    }
  },
  watch: {
    'eventFetchStatus.isFetched': {
      handler(newVal) {
        if (newVal && this.dataWrapper.eventData) {
          this.event = this.dataWrapper.eventData;

          this.timelineData[0].timestamp = this.event.starttime;
          this.timelineData[this.timelineData.length - 1].timestamp = this.event.closetime;
          
          if (this.event.id) {
            this.eventid = this.event.id;
            const requests = [];
            
            requests.push(getEventFiles(this.eventid));
            requests.push(getEventSettings(this.eventid));
            
            Promise.all(requests).then(responses => {
              const filesRes = responses[0];
              if (filesRes.code === 200) {
                this.files = filesRes.list;
              }
              
              if (responses.length > 1) {
                const settingsRes = responses[1];
                if (settingsRes.code === 200) {
                  this.eventSettings = settingsRes.data;
                  const rules = this.eventSettings.rules[0];
            
                  const allowregRule = rules.allowreg ?? false;
                  const midtimeRule  = rules.midtime ?? null;
                  const finaltimeRule = rules.finaltime ?? null;

            
                  if (allowregRule) {
                    this.allowreg = allowregRule;
                  }
            
                  if (midtimeRule) {
                    this.timelineData[1].timestamp = midtimeRule;
                  } else {
                    this.timelineData.splice(1, 1);
                  }
                  
                  if (finaltimeRule) {
                    this.timelineData[2].timestamp = finaltimeRule;
                  } else {
                    this.timelineData.splice(2, 1);
                  }
                }
              }
            });
          }
        }
      },
      immediate: true,
      deep: true
    },
    userProfile: {
      handler(newVal) {
        if (newVal) {
          this.formData.author.realname = this.formData.author.realname || newVal.realname;
          this.formData.author.gender = this.formData.author.gender || newVal.gender;
          this.formData.author.cellphone = this.formData.author.cellphone || newVal.cellphone;
          this.formData.author.institution = this.formData.author.institution || newVal.company;
          this.formData.author.department = this.formData.author.department || newVal.department;
          this.formData.author.position = this.formData.author.position || newVal.position;
          this.formData.author.title = this.formData.author.title || newVal.title;
          this.formData.author.email = this.formData.author.email || newVal.email;
          this.formData.author.age = this.formData.author.age || this.calculateAge(newVal.birthday);
          this.formData.summary = this.formData.summary || newVal.summary;
        }
      },
      immediate: true
    },
    // 监听支付方式变化，重置对应状态
    selectedPaymentMethod: {
      async handler(val) {
        this.paymentQrcodeDataUrl = ''; // 清空二维码
        // 切换非对公转账时，重置备注和截图
        if (val !== 'transfer') {
          this.transferRemark = '';
          this.transferFileList = [];
          this.transferScreenshot = null;
          this.transferPaymentId = ''; // 重置对公转账渠道ID

          if (val === 'alipay'){
            const res = await postCharge({
              orderid: this.orderId,
              paychannelid: this.payment2id,
            });
            
            if (res.code === 201){
              this.alipayQrcodeDataUrl = res.data.qr_code;
            }
          }


        } else {
          // 切换到对公转账时，获取paysource=4的渠道ID
          this.getTransferPaymentId();
        }
      }
    }
  },
  methods: {
    formatTimestampToDate,
    submitForm() {
      if (!this.userProfile) {
        this.$message({
          message: '请先登录',
          type: 'warning',
        });
        return;
      }

      this.$refs.basicForm.validate(async (valid) => {
        if (valid) {
          try {
            this.isSubmitting = true;
            let res;
            if (this.mid) {
              res = await putMeManuscript(this.mid, this.formData);
            } else {
              res = await postManuscript(this.eventid, this.formData);
            }
            if (res.code === 200 || res.code === 201) {
              this.$message.success(this.mid ? '表单更新成功！' : '表单提交成功！');
              this.mid = res.data.id;  
              this.manuscript = res.data;
              this.manuscriptid = res.data.id;            
              this.isSubmitting = false;

              if (res.code == 201){
                this.dialogTipVisible = true;
              }

              this.checkPaymentStatus();


            } else {
              this.$message.error(res.err);
              this.isSubmitting = false;
            }
          } catch (error) {
            console.error('表单操作失败:', error);
            this.$message.error(this.mid ? '表单更新失败，请重试' : '表单提交失败，请重试');
            this.isSubmitting = false;
          }
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.$refs.basicForm.resetFields();
    },

    addAuthor() {
      this.formData.authors.push({
        realname: '',
        gender: '',
        age: null,
        institution: this.formData.author.institution,
        department: this.formData.author.department,
        position: '',
        title: '',
        cellphone: '',
        email: ''
      });
    },
    removeAuthor(index) {
      this.formData.authors.splice(index, 1);
    },
    editAuthor(index) {
      this.editIndex = index;
      this.editAuthorData = { ...this.formData.authors[index] };
      this.editDialogVisible = true;
    },
    saveAuthor() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.formData.authors.splice(this.editIndex, 1, { ...this.editAuthorData });
          this.editDialogVisible = false;
          this.$message.success('成员信息已更新');
        } else {
          this.$message.error('请完善成员信息');
          return false;
        }
      });
    },
    cancelEdit() {
      this.editDialogVisible = false;
    },
    
    // 文件上传失败处理
    handleUploadError(err, file, fileList, fileType) {
      console.log('handleUploadError', err, file, fileList, fileType);
      this.$message.error(`${this.getFileTypeText(fileType)}上传失败，请重试`);
      console.error(`${this.getFileTypeText(fileType)}上传失败:`, err);
    },
    
    // 获取文件类型文本
    getFileTypeText(fileType) {
      switch(fileType) {
        case 'application': return '报名材料';
        case 'midterm': return '中期材料';
        case 'final': return '结项材料';
        default: return '文件';
      }
    },
    handlePreview(file) {
      console.log('preview',file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    beforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error('上传附件大小不能超过 20MB!');
      }
      return isLt20M;
    },
    handleChange(file, fileList) {
      console.log(file, fileList);
    },
    calculateAge(birthdayTimestamp) {
      if (!birthdayTimestamp || typeof birthdayTimestamp !== 'number') {
        return null;
      }
      const birthDate = new Date(birthdayTimestamp * 1000);
      const today = new Date();
      
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age > 0 ? age : null;
    },
    fetchManuscript() {
      if (this.manuscriptid) {
        getManuscript(this.eventid, this.manuscriptid).then((res) => {
          this.isLoading = false;
          const checkCuid = this.$route.query.checkCuid;
          if (res.code === 200 && (!checkCuid || res.data?.cuid == this.userProfile.id)) {
            this.manuscript = res.data;
            this.mid = this.manuscript.id;

            this.formData.title = this.manuscript.title;
            this.formData.summary = this.manuscript.summary;
            this.formData.authors = this.manuscript.authors || [];
            this.formData.author = this.manuscript.author;

            this.fetchFiles(this.mid);
            // 检查支付状态（使用缓存的票价数据）
            this.checkPaymentStatus();
          }
        });
      } else {
        getMeManuscripts().then((res) => {
          this.isLoading = false;
          if (res.code === 200) {
            const manuscripts = res.list || [];
            const checkCuid = this.$route.query.checkCuid;
            this.manuscript = manuscripts.filter(manu => {
              const eventidMatch = manu.eventid === this.eventid;
              const cuidMatch = checkCuid ? manu.cuid === this.userProfile.id : true;
              return eventidMatch && cuidMatch;
            })[0];
            if (this.manuscript) {
              this.mid = this.manuscript.id;
              
              this.formData.title = this.manuscript.title;
              this.formData.summary = this.manuscript.summary;
              this.formData.authors = this.manuscript.authors || [];
              this.formData.author = this.manuscript.author;

              this.fetchFiles(this.mid);
              // 检查支付状态（使用缓存的票价数据）
              this.checkPaymentStatus();
            }
          } else if (res.code === 401) {
            this.$message({
              message: '请先登录',
              type: 'warning',
            });
            return;
          }
        });
      }
    },
    // 重构 fetchPaymentsData 方法，接收 orderid 参数
    async fetchPaymentsData(orderId) {
      try {
        const res = await getPaychannels(orderId || this.orderId);
        console.log('获取支付配置:', res);
        if (res.code === 200 && res.list && res.list.length > 0) {
          // 过滤出paysource == 3的数据
          const payment3Item = res.list.find(item => item.paysource === 3);
          if (payment3Item && payment3Item.id) {
            this.payment3id = payment3Item.id;
          } else {
            // throw new Error('未找到有效的微信支付渠道');
          }

          //支付宝
          const payment2Item = res.list.find(item => item.paysource === 2);
          if (payment2Item && payment2Item.id) {
            this.payment2id = payment2Item.id;
          } else {
            // throw new Error('未找到有效的支付宝支付渠道');
          }

          // 过滤出paysource == 4的数据，对公转账
          const payment4Item = res.list.find(item => item.paysource === 4);
          console.log('payment4Item:', payment4Item);
          if (payment4Item && payment4Item.id) {
            this.payment4id = payment4Item.id;
          }

          if (payment4Item && payment4Item?.name){
            this.paymentMethods[2].accountInfo.accountName = payment4Item?.name;
          }
          if (payment4Item && payment4Item?.no){
            this.paymentMethods[2].accountInfo.accountNo = payment4Item?.no;
          }
          if (payment4Item && payment4Item?.bank){
            this.paymentMethods[2].accountInfo.bankName = payment4Item?.bank;
          }

        } else {
          throw new Error('获取支付渠道列表失败');
        }
      } catch (error) {
        console.error('获取支付配置失败:', error);
        this.$message.error('获取支付配置失败，请重试');
        throw error; // 抛出错误，让上层处理
      }
    },
    // 查询是否存在有效的未支付订单
    async getExistingValidOrder() {
      try {
        if (!this.mid) {
          return null;
        }
        
        // 查询条件：关联当前稿件、类型为4、状态为未支付
        const meOrdersRes = await getMeOrders({
          filter: {
            validstatus: true,
            refid: this.mid,
            status: 0,  // 0表示未支付
            type: 4     // 4对应评审费订单
          }
        });
        
        if (meOrdersRes.code === 200 && meOrdersRes.data && meOrdersRes.data.list.length > 0) {
          // 过滤出有效的订单（type=4 且 refid匹配）
          const validOrders = meOrdersRes.data.list.filter(order => 
            order.type === 4 && order.refid === this.mid
          );
          
          if (validOrders.length > 0) {
            // 返回第一个有效订单
            return validOrders[0];
          }
        }
        
        return null;
      } catch (error) {
        console.error('查询订单失败:', error);
        // 订单查询失败时，允许创建新订单
        return null;
      }
    },
    // 创建新订单（抽离独立方法）
    async createOrder() {
      try {
        if (!this.mid || !this.manuscript || !this.ticket) {
          throw new Error('创建订单的必要信息不完整');
        }
        
        const guests = [
          {
            goodid      : this.ticket.id,
            cellphone   : this.manuscript.author.cellphone,
            realname    : this.manuscript.author.realname,
            title       : this.manuscript.author.title,
            company     : this.manuscript.author.institution,
            email       : this.manuscript.author.email,
            department  : this.manuscript.author.department,
          }
        ];
        
        const metas = {
          'guests' : guests,
        };

        const params = {
          refid     : this.mid,
          type      : 4,
          cellphone : this.manuscript.author.cellphone,
          realname  : this.manuscript.author.realname,
          title     : this.manuscript.author.title,
          company   : this.manuscript.author.company,
          email     : this.manuscript.author.email,
          department: this.manuscript.author.department,
          cartitems : [
            {
              goodid  : this.ticket.id,
              goodnum : 1,
              quantity: 1,
              guests  : guests,
            },
          ],
          metaitems : metas  
        }; 
        
        console.log('创建新订单参数:', params);
        const orderRes = await postOrder(params);
        
        if (orderRes.code !== 201) {
          throw new Error(orderRes.err || '创建订单失败');
        }
        
        // 保存新订单ID
        this.orderId = orderRes.data.id;
        // 保存订单金额（单位：分）
        this.orderPrice = (orderRes.data.amount / 100).toFixed(2);
        this.orderStatus = orderRes.data.paystatus;
        
        console.log('创建新订单成功，订单ID:', this.orderId);
        
        return this.orderId;
      } catch (error) {
        console.error('创建订单失败:', error);
        throw new Error(error.message || '创建订单失败，请稍后重试');
      }
    },
    fetchFiles(mid) {
      getMeManuscriptFile(mid, {
        filter : {
          status: 100,
        }
      }).then((res) => {
        if (res.code === 200) {
          this.files1 = [];
          this.files2 = [];
          this.files3 = [];
          
          const files = res.list || [];
          files.forEach(file => {
            if (file.meta) {
              if (file.meta.type === 1) {
                this.files1.push(file);
              } else if (file.meta.type === 2) {
                this.files2.push(file);
              } else if (file.meta.type === 3) {
                this.files3.push(file);
              }
            }
          });
        }
      });
    },
    handleUserLoggedIn(){
      this.eventid = this.$route.params.id;
      this.event = this.dataWrapper.eventData;  

      this.manuscriptid = this.$route.query.manuscriptid || null;
      // 登录后先确保票价已加载，再获取稿件信息
      this.getTicketPrice(true)
        .then(() => {
          this.fetchManuscript();
        });
    },
    handleUserLoggedOut() {
      this.manuscript = null;
      this.resetForm();
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleUploadSuccess(res, file, fileList) {
      console.log('上传成功:', res);
      console.log('上传文件:', file);
      console.log('当前文件列表:', fileList);
    },
    uploadAction1(options) {
      const file = options.file;
      this.uploadLoading = true;
      
      postMeManuscriptFile(this.mid, file, {
        status:100,
        meta: {
          'type': 1,
        }
      }).then((res) => {
        if (res.code === 201) {
          this.$message.success('上传成功');
          this.fetchManuscript();
        } else {
          this.$message.error(res.msg || '上传失败');
        }
      }).catch((error) => {
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }).finally(() => {
        this.uploadLoading = false;
      });
    },
    uploadAction2(options) {
      const file = options.file;
      this.uploadLoading = true;
      
      postMeManuscriptFile(this.mid, file, {
        status:100,
        meta: {
          'type': 2,
        }
      }).then((res) => {
        if (res.code === 201) {
          this.$message.success('上传成功');
          this.confirmFile(this.mid);
          this.fetchManuscript();
        } else {
          this.$message.error(res.msg || '上传失败');
        }
      }).catch((error) => {
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }).finally(() => {
        this.uploadLoading = false;
      });
    },
    uploadAction3(options) {
      const file = options.file;
      this.uploadLoading = true;
      
      postMeManuscriptFile(this.mid, file, {
        status:100,
        meta: {
          'type': 3,
        }
      }).then((res) => {
        if (res.code === 201) {
          this.$message.success('上传成功');
          this.confirmFile(this.mid);
          this.fetchManuscript();
        } else {
          this.$message.error(res.msg || '上传失败');
        }
      }).catch((error) => {
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }).finally(() => {
        this.uploadLoading = false;
      });
    },
    downloadFile(url) {
      window.location.href = url;
    },
    removeFile(id) {
      offlineMeManuscriptFile(this.mid, id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchFiles(this.mid);
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      });
    },
    confirmFile(id) {
      confirmMeManuscript(id).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg || '确认失败');
        }
      });
    },
    onDataUrlChange(dataUrl) {
      this.qrcodeDataUrl = dataUrl;
    },
    // 支付二维码生成回调
    onPaymentQrcodeChange(dataUrl) {
      console.log('支付二维码:', dataUrl);
      this.paymentQrcodeDataUrl = dataUrl;
    },
    beforeDestroy() {
      eventBus.$off('userLoggedIn', this.handleUserLoggedIn);
      eventBus.$off('userLoggedOut', this.handleUserLoggedOut);
    },
    /**
     * 将日期转换为当日23:59:59的时间戳（秒级）
     */
    getEndOfDayTimestamp(date) {
      if (!date) return 0;
      
      const targetDate = new Date(typeof date === 'number' ? date * 1000 : date);
      targetDate.setHours(23, 59, 59, 999);
      return Math.floor(targetDate.getTime() / 1000);
    },
    /**
     * 判断当前 timeline 项是否需要红色高亮
     */
    isTimelineItemActive(item, index) {
      if (!this.manuscript) {
        if (index === 0 && item.timestamp) {
          const currentTime = Math.floor(Date.now() / 1000);
          const itemEndTime = this.getEndOfDayTimestamp(item.timestamp);
          return currentTime <= itemEndTime;
        }
        return false;
      }

      if (!item.timestamp || !item.title) return false;

      const currentTime = Math.floor(Date.now() / 1000);
      const itemEndTime = this.getEndOfDayTimestamp(item.timestamp);
      const manuscriptStatus = this.manuscript.status;
      const highlightMap = [
        { statusList: [0, 1], targetIndex: 1 },
        { statusList: [2, 3], targetIndex: 2 },
      ];

      const targetConfig = highlightMap.find(item => item.statusList.includes(manuscriptStatus));
      if (!targetConfig) return false;

      return index === targetConfig.targetIndex && currentTime <= itemEndTime;
    },
    formatTimelineTimestamp(timestamp) {
      if (!timestamp) return '';
      const baseDateText = this.formatTimestampToDate(timestamp);
      const currentTime = Math.floor(Date.now() / 1000);
      const itemEndTime = this.getEndOfDayTimestamp(timestamp);
      const isExpired = currentTime > itemEndTime;

      return isExpired 
        ? `${baseDateText} <span class="expired-tag">（已结束）</span>` 
        : baseDateText;
    },
    // ========== 支付相关核心方法 ==========
    // 对公转账截图上传变更
    handleTransferScreenshotChange(file, fileList) {
      this.transferFileList = fileList;
      this.transferScreenshot = file.raw;
      // 限制文件大2MB
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('付款截图大小不能超过 2MB!');
        this.transferFileList = [];
        this.transferScreenshot = null;
      }
    },
    // 对公转账截图移除
    handleTransferScreenshotRemove() {
      this.transferFileList = [];
      this.transferScreenshot = null;
    },
    // 微信/支付宝支付-我已付款
    async handlePaymentCompleted() {
      this.paymentLoading = true;
      try {
        //根据getOrder 获取订单详情
        getOrder(this.orderId).then((result) => {
          const res = result.data;
          if(res.paystatus == 99 || res.paystatus == 100 || res.paystatus == 50){
            this.$message.success('支付确认提交成功');

            this.paymentCompleted = true;
            this.showPaymentPanel = false;
            
            // 重置支付相关状态
            this.transferRemark = '';
            this.transferScreenshot = null;
            this.transferFileList = [];
            this.selectedPaymentMethod = 'wechat';
            this.transferPaymentId = '';

            //刷新当前页面
            window.location.reload();

          }else{
            this.$message.error('订单未支付，请先支付订单');
          }
        });

      } catch (error) {
        console.error('支付确认失败:', error);
        this.$message.error('支付确认提交失败，请稍后重试');
      } finally {
        this.paymentLoading = false;
      }
    },
    // 对公转账-提交（带表单校验）
    // async handleTransferSubmit() {
    //   try {
    //     // 1. 确保有有效的订单ID（先查后建）
    //     if (!this.orderId) {
    //       const existingOrder = await this.getExistingValidOrder();
    //       if (existingOrder) {
    //         this.orderId = existingOrder.id;
    //       } else {
    //         await this.createOrder();
    //       }
    //     }

    //     // 2. 确保已获取对公转账渠道ID
    //     if (!this.transferPaymentId) {
    //       await this.getTransferPaymentId(); // 主动重试获取
    //       if (!this.transferPaymentId) {
    //         throw new Error('未获取到对公转账支付渠道信息，无法提交');
    //       }
    //     }

    //     // 3. 截图校验
    //     if (!this.transferScreenshot) {
    //       this.$message.warning('请上传付款截图');
    //       return;
    //     }

    //     this.paymentLoading = true;
        
    //     // 4. 提交转账凭证逻辑（可传入transferPaymentId）
    //     console.log('提交对公转账凭证，渠道ID:', this.transferPaymentId);
    //     // 此处可将this.transferPaymentId传入后端接口，示例：
    //     // const submitRes = await submitTransferVoucher({
    //     //   orderId: this.orderId,
    //     //   paymentId: this.transferPaymentId,
    //     //   remark: this.transferRemark,
    //     //   screenshot: this.transferScreenshot
    //     // });

    //     // localStorage.setItem(`paymentStatus_${this.mid}`, 'transfer_submitted');
    //     this.$message.success('转账凭证提交成功，财务将尽快审核，审核通过后将短信通知');
    //     this.showPaymentPanel = false;
        
    //     // 5. 重置表单
    //     this.transferRemark = '';
    //     this.transferScreenshot = null;
    //     this.transferFileList = [];
    //     this.selectedPaymentMethod = 'wechat';
    //     this.transferPaymentId = ''; // 重置渠道ID
    //   } catch (error) {
    //     console.error('转账凭证提交失败:', error);
    //     this.$message.error(error.message || '转账凭证提交失败，请稍后重试');
    //   } finally {
    //     this.paymentLoading = false;
    //   }
    // },
    // 检查支付状态（使用缓存的票价数据）
    async checkPaymentStatus() {
      // 增加数据存在性校验
      if (!this.manuscript) {
        return;
      }
      
      // 如果有订单且未支付，检查是否有已创建的订单
      if (this.ticket && Number(this.ticket.price) > 0 && this.mid && this.manuscript.orderpaystatus < 99) {
        const meOrders = await getMeOrders({
          filter: {
            validstatus: true,
            refid: this.mid,
            status: 0,
            type:4,
          }
        });
        //过滤meOrders，只保留type=4的订单
        const validOrders = meOrders.data.list.filter(order => order.type === 4 && order.refid === this.mid);

        console.log('validOrders:', validOrders);

        //如果validOrders订单是免费的，不需要弹框提示
        if (validOrders.some(order => Number(order.amount) === 0)) {
          return;
        }

        //如果validOrders订单有paystatus=50,转账待确认状态的，不需要弹框提示
        if (validOrders.some(order => order.paystatus === 50)) {
          return;
        }
        console.log('validOrders:', validOrders);


        //再过滤 expiretime 不超过当前时间的订单
        // const validOrders = meOrders.data.list.filter(order => order.type === 4 && order.refid === this.mid && order.expiretime > Math.floor(Date.now() / 1000));


        if (validOrders.length){
          this.orderId = validOrders[0].id;
          // 保存订单金额（单位：分）
          this.orderPrice = (validOrders[0].amount / 100).toFixed(2);

          // 保存订单状态
          this.orderStatus = validOrders[0].paystatus;
        }

        console.log('checkPaymentStatus: 有效订单', validOrders);

        this.paymentReminderVisible = true;
      } else {
          console.log('checkPaymentStatus: 无需显示支付提醒', {
          ticketPrice: this.ticket?.price,
          mid: this.mid,
          orderpaystatus: this.manuscript?.orderpaystatus
        });
      }
    },
    // 重构：带缓存机制的 getTicketPrice 方法
    async getTicketPrice(forceRefresh = false) {
      // 如果已经获取过且不是强制刷新，直接返回缓存数据
      if (this.ticketFetched && !forceRefresh) {
        this.ticket = this.ticketCache;
        return this.ticket;
      }
      
      try {
        const res = await getEventTicketList(this.eventid);
        if (res.code === 200 && res.list && res.list.length > 0) {
          const currentTime = Math.floor(Date.now() / 1000);
          const validTickets = res.list.filter(ticket => 
            ticket.status === 100 && 
            ticket.salestart < currentTime && 
            ticket.saleclose > currentTime
          );
          
          if (validTickets.length > 0) {
            // 保留原始 ticket 数据（包含 id），只格式化价格
            this.ticketCache = {
              ...validTickets[0],
              price: (validTickets[0].price / 100).toFixed(2)
            };
          } else {
            this.ticketCache = { price: '0.00' };
          }
        } else {
          this.ticketCache = { price: '0.00' };
        }
        
        // 更新缓存标记和当前 ticket 数据
        this.ticketFetched = true;
        this.ticket = this.ticketCache;
        
        return this.ticket;
      } catch (error) {
        console.error('获取票价失败:', error);
        this.ticketCache = { price: '0.00' };
        this.ticket = this.ticketCache;
        return this.ticket;
      }
    },
    // 优化：去支付方法（先查订单，有则用，无则创建）
    async handleGoToPayment() {
      this.paymentReminderVisible = false;
      
      try {
        // 1. 先查询是否存在未支付的有效订单
        const existingOrder = await this.getExistingValidOrder();
        console.log('existingOrder:', existingOrder);
        if (existingOrder) {
          // 使用已有订单
          this.orderId = existingOrder.id;
          // 保存订单金额（单位：分）
          this.orderPrice = (existingOrder.amount / 100).toFixed(2);
          // 保存订单状态
          this.orderStatus = existingOrder.paystatus;
          // this.$message.info('检测到未支付订单，将使用该订单继续支付');
        } else {
          // 创建新订单
          await this.createOrder();
        }
        
        // 2. 获取支付配置（传入订单ID）
        await this.fetchPaymentsData(this.orderId);

        // 3. 检查关键数据是否就绪
        if (!this.orderId || !this.payment3id) {
          throw new Error('支付配置信息获取失败，请稍后重试');
        }
        
        // 4. 显示支付面板
        this.showPaymentPanel = true;
      } catch (error) {
        console.error('处理支付失败:', error);
        this.$message.error(error.message || '处理支付请求失败，请稍后重试');
        this.showPaymentPanel = false;
      }
    },
    // 生成支付二维码链接
    getPaymentQrcodeUrl() {
      // 确保订单ID和支付ID存在
      if (!this.orderId || !this.payment3id) {
        return ''; // 静默返回空，不弹出警告
      }
      
      if (this.selectedPaymentMethod === 'wechat') {
        return `${config.WX_BASE_URL}pay?id=${this.orderId}&paychannelid=${this.payment3id}`;
      } else if (this.selectedPaymentMethod === 'alipay') {
        return this.alipayQrcodeDataUrl;
      }
      return '';
    },
    getTransferQrcodeUrl() {
      if (!this.orderId) {
        return ''; // 订单ID为空时返回空
      }
      return `${config.WX_BASE_URL}order?id=${this.orderId}`;
    },
    // 获取对公转账渠道ID（paysource=4）
    async getTransferPaymentId() {
      try {
        if (!this.orderId) {
          this.$message.warning('订单信息未就绪，请稍后重试');
          return;
        }
        
        // 调用getOrderCharges接口，传入订单ID
        // const res = await postCharge({
        //   orderid: this.orderId,
        //   paymentid: this.payment4id,
        // });
        // if (res.code === 200 && res.list && res.list.length > 0) {
        //   // 筛选paysource=4的记录
        //   const transferChannel = res.list.find(item => item.paysource === 4);
        //   if (transferChannel && transferChannel.id) {
        //     this.transferPaymentId = transferChannel.id;
        //     console.log('获取对公转账渠道ID成功:', this.transferPaymentId);
        //   } else {
        //     this.$message.warning('未找到对公转账支付渠道，请联系客服');
        //     this.transferPaymentId = '';
        //   }
        // } else {
        //   this.$message.warning('获取支付渠道失败，请稍后重试');
        //   this.transferPaymentId = '';
        // }
      } catch (error) {
        console.error('获取对公转账渠道ID失败:', error);
        this.$message.error('获取支付渠道失败，请稍后重试');
        this.transferPaymentId = '';
      }
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.pc-padding {
  padding-left: 150px;
  padding-right: 150px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .pc-padding {
    padding-left: 20px;
    padding-right: 20px;
  }

  .upload-card {
    padding: 10px;
  }
  
  .el-upload {
    width: 100% !important;
  }
  
  .el-upload__text {
    font-size: 14px;
    padding: 0 10px;
  }
  
  .el-upload__tip {
    font-size: 12px;
    word-break: break-all;
  }
}

/* 时间线样式 */
.timeline-section {
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 4px;
}

.form-actions {
  margin-top: 30px;
}

::v-deep .el-timeline {
  padding-left: 20px;
}

::v-deep .el-timeline-item {
  margin-bottom: 20px;
}

::v-deep .el-card {
  margin-top: 10px;
}

/* 通用样式 */
.info-label {
  color: #333333;
  margin-right: 5px;
}

h5 {
  font-size: 1.18rem;
}
:deep(.el-form-item__label){
  font-weight: 400;
}
:deep(.el-descriptions-item__label.has-colon::after) {
  content: none;
}
:deep(.el-descriptions-item__label:not(.is-bordered-label)){
  margin-right: 0;
}
.text-red {
  color: red;
}

/* 联系方式样式 */
.contact-tip {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.contact-info {
  background: #f9f9f9;
  padding: 15px;
}

.qrcode-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.qrcode-tip {
  color: #666;
  font-size: 14px;
}
.qrcode-img {
  margin: 0 auto;
  display: block;
  width: 150px;
  height: 150px;
}

/* 上传卡片样式 */
.upload-card {
  background: #fff;
  border: 2px solid #409EFF;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.15);
  margin-bottom: 20px;
}
.upload-title {
  font-size: 18px;
  font-weight: 700;
  color: #409EFF;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #E6F2FF;
}
.el-upload__tip {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}
.el-upload__tip .text-red {
  font-size: 15px;
  font-weight: 500;
}

/* 时间线优化样式 */
.timeline-section {
  padding: 15px;
}
::v-deep .el-timeline {
  padding-left: 10px;
}
::v-deep .el-timeline-item {
  margin-bottom: 10px;
}
::v-deep .el-timeline-item__timestamp {
  font-size: 12px;
  margin-bottom: 5px;
}
::v-deep .el-card {
  margin-top: 5px;
  padding: 10px;
}
::v-deep .el-card h4 {
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: 600;
}
::v-deep .el-card p {
  font-size: 12px;
  margin-bottom: 0;
}
::v-deep .el-card__body {
  padding: 2px 0;
}
::v-deep .expired-tag {
  color: #E53E3E;
  font-size: 11px;
  font-weight: 400;
}

::v-deep .timeline-red-highlight {
  .el-timeline-item__timestamp {
    color: #F56C6C !important;
    font-weight: 600;
  }

  .el-timeline-item__node {
    background-color: #F56C6C !important;
    border-color: #F56C6C !important;
  }

  .el-card h4 {
    color: #F56C6C !important;
    font-weight: 700;
  }

  .el-card {
    background-color: #FFF2F2 !important;
    border: 1px solid #FDE2E2 !important;
    padding: 12px 16px;
    border-radius: 8px;
  }
}

/* 支付面板样式 */
.payment-container {
  /* padding: 20px 0; */
  text-align: center;
}
.payment-header {
  text-align: center;
  margin-bottom: 20px;
}
.price {
  font-size: 24px;
  font-weight: bold;
  color: #F56C6C;
  margin-top: 10px;
}
.payment-methods {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  gap: 20px;
}
.payment-methods ::v-deep .el-radio {
  font-size: 16px;
}
.qrcode-section {
  text-align: center;
  padding: 10px 0;
}
.payment-qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.transfer-section {
  margin-top: 10px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: left;
}
.transfer-upload ::v-deep .el-upload {
  margin-top: 5px;
}
.upload-tip {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.mt-5 {
  margin-top: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.text-red {
  color: #F56C6C;
  font-size: 12px;
}
:deep(.el-dialog__body){
  padding: 0 20px 20px 20px;
}
:deep(.transfer-form .el-form-item) {
  margin-bottom: 0;
}
</style>